import { hooks } from '@wove/react';
import { FC, useRef, useState } from 'react';
import { Image } from '../image';
import { ModalFull } from '../modal-full';
import { Swiper, SwiperItem } from '../swiper';
import { Zoom } from '../zoom';
import './style.less';

export type ImageViewerProps = {
  images: string[];
  visible: boolean;
  onClose: () => void;
  initActiveIndex?: number;
  onAfterClose?: () => void;
  destroyOnClose?: boolean;
  loop?: boolean;
  lazy?: boolean;
  maxZoom?: number;
};

export const ImageViewerInner: FC<ImageViewerProps> = (props) => {
  const [renderSwiper, setRenderSwiper] = useState(false);
  const [currentNum, setCurrentNum] = useState(props.images.length > 0 ? 1 : 0);
  const swiperInstanceRef = useRef<Record<string, any>>({});

  /**
   * 由于swiper渲染受到modal弹窗缩放过程影响，导致swiper宽度计算错误，此处在onAfterOpen后渲染swiper
   */
  const onAfterOpen = hooks.useCallbackRef(() => {
    setTimeout(() => {
      setRenderSwiper(true);
    }, 50);
  });
  const slideChanged = hooks.useCallbackRef((e) => {
    setCurrentNum((e.track.details.rel as number) + 1);
  });

  const swiperOption = {
    slides: {
      spacing: 15,
    },
    loop: props.loop,
    slideChanged,
  };

  return (
    <ModalFull
      visible={props.visible}
      className="v-image-viewer-modal"
      onAfterOpen={onAfterOpen}
      onClose={props.onClose}
      maskStyle={{ background: 'rgba(0, 0, 0, 0.75)' }}
      onAfterClose={props.onAfterClose}
      destroyOnClose={props.destroyOnClose}
    >
      {props.images.length > 1 && (
        <div className="v-image-viewer-dot">
          {currentNum}/{props.images.length}
        </div>
      )}
      {renderSwiper && (
        <Swiper
          dot={false}
          option={{
            ...swiperOption,
            created: (e) => {
              swiperInstanceRef.current = e;
              if (props.initActiveIndex) {
                e.moveToIdx(props.initActiveIndex, true, { duration: 0 });
              }
            },
          }}
        >
          {props.images.map((item, index) => {
            return (
              <SwiperItem key={index}>
                <Zoom
                  maxZoom={props.maxZoom}
                  onZoomChange={(zoom) => {
                    if (zoom === 1) {
                      swiperInstanceRef.current.update({
                        drag: true,
                        ...swiperOption,
                      });
                    } else {
                      swiperInstanceRef.current.update({
                        drag: false,
                        ...swiperOption,
                      });
                    }
                  }}
                >
                  <Image
                    src={item}
                    imgProps={{ style: { objectFit: 'contain' } }}
                    onClick={props.onClose}
                    width={'100%'}
                    height={'100%'}
                    lazy={props.lazy}
                  />
                </Zoom>
              </SwiperItem>
            );
          })}
        </Swiper>
      )}
    </ModalFull>
  );
};

ImageViewerInner.defaultProps = {
  lazy: true,
  loop: false,
  maxZoom: 2,
};
